import { createContext } from 'react';
export var primaryDimensionLengthContext = createContext(0);
